import React from 'react'

import type { RemoveLiquidityControllerResult } from '@/features/liquidity/useRemoveLiquidityController'

import {
  LiquidityNutrimaticMobileRemoveFormView,
  LiquidityNutrimaticMobileRemoveReviewView,
  LiquidityNutrimaticMobileRemoveSuccessView,
  LiquidityNutrimaticMobileRemoveCancelledView,
  LiquidityNutrimaticMobileRemoveErrorView,
} from '../mobile/LiquidityNutrimaticMobileRemoveView'
import { useLiquidityRemoveNutrimaticFlow } from '../useLiquidityRemoveNutrimaticFlow'

/** Panel derecho de la tableta para retirar liquidez (form → review → success). */
export function LiquidityNutrimaticRemovePerformStack({
  controller,
}: {
  controller: RemoveLiquidityControllerResult
}) {
  const { screen } = useLiquidityRemoveNutrimaticFlow(controller)

  return (
    <div className="nm-tablet-trade__stage-stack" data-nutrimatic-mobile-simple>
      <div
        className="nm-mobile-simple__stage nm-mobile-simple__convert-layer flex min-h-0 flex-col overflow-hidden"
        hidden={screen !== 'form'}
        aria-hidden={screen !== 'form'}
      >
        <LiquidityNutrimaticMobileRemoveFormView controller={controller} variant="desktop-tablet" />
      </div>

      <div
        className="nm-mobile-simple__stage nm-mobile-simple__review-stage flex min-h-0 flex-col overflow-hidden"
        hidden={screen !== 'review'}
        aria-hidden={screen !== 'review'}
      >
        <LiquidityNutrimaticMobileRemoveReviewView controller={controller} variant="desktop-tablet" />
      </div>

      <div
        className="nm-mobile-simple__stage nm-mobile-simple__success-stage flex min-h-0 flex-col overflow-hidden"
        hidden={screen !== 'success'}
        aria-hidden={screen !== 'success'}
      >
        <LiquidityNutrimaticMobileRemoveSuccessView controller={controller} />
      </div>

      <div
        className="nm-mobile-simple__stage nm-mobile-simple__outcome-stage flex min-h-0 flex-col overflow-hidden"
        hidden={screen !== 'cancelled'}
        aria-hidden={screen !== 'cancelled'}
      >
        <LiquidityNutrimaticMobileRemoveCancelledView controller={controller} />
      </div>

      <div
        className="nm-mobile-simple__stage nm-mobile-simple__outcome-stage flex min-h-0 flex-col overflow-hidden"
        hidden={screen !== 'error'}
        aria-hidden={screen !== 'error'}
      >
        <LiquidityNutrimaticMobileRemoveErrorView controller={controller} />
      </div>
    </div>
  )
}
